<template>
  <div class="contact">
    <HightLight bg-text="Contact Us" :is-bg="true" text="联系我们" class="title"></HightLight>
    <div class="content">
      <div class="top">
        <img src="../../assets/images/contact/ewm.png" alt="">
        <div class="mes">
          <div class="company">中鹏（浙江）机械有限公司</div>
<!--          <div>-->
<!--            <i class="el-icon-house">公司门市部：</i>-->
<!--            <span style="margin-left: 8px">中国浙江省台州市黄岩区鉴湖村(梅山223号)</span>-->
<!--          </div>-->
          <div>
            <i class="el-icon-mobile">手机(M.P)：</i>
            <span style="margin-left: 8px;margin-right: 60px">13905764593(张先生)</span>

            <i class="el-icon-user">微信号：</i>
            <span style="margin-left: 8px">13905764593</span>
          </div>
          <div>
            <i class="el-icon-phone-outline">售后服务(Tel)：</i>
            <span style="margin-left: 8px;margin-right: 60px">086-18257620988</span>

            <i class="el-icon-message">邮编(P.c)：</i>
            <span style="margin-left: 8px">318015</span>
          </div>
          <div>
            <i class="el-icon-location-information">地址(add)：</i>
            <span style="margin-left: 8px">浙江省台州市椒江区洪家街道钢材五金市场C区599号</span>
            <br/>
            <span style="margin-left: 8px">No.C599,hongjia Combined Steel Market,jiaojiang Distric,taizhou,zhejiang,p.r. China</span>
          </div>
        </div>
      </div>

      <div id="map" style="width:1200px;height:389px;"></div>
    </div>
  </div>
</template>

<script>
  import HightLight from "@/components/common/hightLight/HightLight";
  export default {
    name: "Contact",
    components:{
      HightLight
    },
    mounted(){
      let map = new BMap.Map("map");
      let point = new BMap.Point(121.406011,28.612325);
      map.centerAndZoom(point, 18);
      map.addControl(new BMap.NavigationControl());//添加控件
      map.addControl(new BMap.ScaleControl());
      map.addControl(new BMap.OverviewMapControl());
      map.addControl(new BMap.MapTypeControl());
      map.enableScrollWheelZoom(true);//开启滚动
      var marker = new BMap.Marker(point);        // 创建标注
      map.addOverlay(marker);
    }
  }
</script>
<style lang="less" scoped>
.contact{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  .top{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #cccccc;
    padding: 0 0 26px  65px;
    margin-bottom: 26px;
    img{
      padding-right: 16px;
      height: 200px;
      width: 200px;
      border-right: 1px solid #cccccc;
    }
    .mes {
      height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 16px;
      .company {
        font-size: 24px;
      }
    }
  }
}


  #map{
    margin-bottom: 25px;
  }
  .title{
    margin-right: 13px;
  }
  .tag{
    text-align: center;
    margin-bottom: 25px;
    font-size: 28px;
    font-weight: bolder;
    color: red;
  }
</style>
